export default ({store, from, redirect}) => {
  if (store.state.form.hasChanged && !confirm('Weet je zeker dat je deze pagina wilt verlaten?')) {
    return redirect(from);
  }

  store.dispatch('form/setChanged', false);
};
